import { memo } from 'react';

import { useTheme, Typography, Box } from '@mui/material';

import getHeadingVariant from '@/utils/resolveContentfulHeadingVariant';
import resolveContentfulHeadingTag from '@/utils/resolveContentfulHeadingTag';
import { ContentSection } from '@/types/generated';
import { HeadingTag } from '@/types';

import { getEyebrowStyles, getHeadingStyles, headingWrapperStyles } from './Heading.styles';

type HeadingProps = Pick<ContentSection, 'eyebrow' | 'eyebrowHtag' | 'title' | 'titleHtag'>;

export default memo(function Heading({ eyebrowHtag = 'h4', eyebrow, title, titleHtag = 'h1' }: HeadingProps) {
	const theme = useTheme();

	return (
		<Box data-testid="product_feature_heading_box" sx={headingWrapperStyles}>
			{eyebrow && (
				<Typography
					data-testid="product_feature_eyebrow_text"
					variant={getHeadingVariant(eyebrowHtag as HeadingTag)}
					sx={getEyebrowStyles(theme)}
					component={resolveContentfulHeadingTag(eyebrowHtag as HeadingTag)}
				>
					{eyebrow}
				</Typography>
			)}
			{title && (
				<Typography
					data-testid="product_feature_heading_text"
					variant={getHeadingVariant(titleHtag as HeadingTag)}
					sx={getHeadingStyles(theme)}
					component={resolveContentfulHeadingTag(titleHtag as HeadingTag)}
				>
					{title}
				</Typography>
			)}
		</Box>
	);
});
